import { css } from '@creditas/stylitas'

import { rtNamespace, rtZIndex } from './variables'

const progressBar = css`
  @keyframes ${rtNamespace}__trackProgress {
    0% {
      transform: scaleX(1);
    }
    100% {
      transform: scaleX(0);
    }
  }

  .${rtNamespace}__progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    z-index: ${rtZIndex};
    opacity: 0.7;
    transform-origin: left;

    &--animated {
      animation: ${rtNamespace}__trackProgress linear 1 forwards;
    }

    &--controlled {
      transition: transform 0.2s;
    }

    &--rtl {
      right: 0;
      left: initial;
      transform-origin: right;
    }
    &--default {
    }
    &--info {
      background: #4499ee;
    }
    &--success {
    }
    &--warning {
    }
    &--error {
      background: #dd2222;
    }
  }
`

export { progressBar }
